import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fd0f1322"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "trade-menu-list"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-ai_icon"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "寻源宝", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-tip"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "btn-tip-bg"
}, [/*#__PURE__*/_createElementVNode("span", null, "智能采购")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_button = _resolveComponent("el-button");
  const _component_client_only = _resolveComponent("client-only");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createElementBlock("menu", {
    class: _normalizeClass(['trade-menu', _ctx.adaptWise && 'is-menu-adapt-wise'])
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_menu, {
    "default-active": _ctx.activeIndex,
    mode: "horizontal",
    ellipsis: false,
    router: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_client_only, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, menu => {
        return _openBlock(), _createElementBlock(_Fragment, null, [menu !== null && menu !== void 0 && menu.children ? (_openBlock(), _createBlock(_component_el_sub_menu, {
          key: menu.channel,
          index: menu.channel,
          "popper-class": "sub-menu-popup"
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(menu.text), 1)]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, menuItem => {
            return _openBlock(), _createBlock(_component_el_menu_item, {
              key: menuItem.name,
              index: menuItem.route.path
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(menuItem.text), 1)]),
              _: 2
            }, 1032, ["index"]);
          }), 128))]),
          _: 2
        }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
          key: menu.name,
          index: menu.route.path
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(menu.text), 1)]),
          _: 2
        }, 1032, ["index"]))], 64);
      }), 256)), _createVNode(_component_el_button, {
        class: "go-aibot-btn",
        text: "",
        onClick: _ctx.handleJumpToAibot
      }, {
        default: _withCtx(() => [_hoisted_2, _hoisted_3, _hoisted_4]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["default-active"])])], 2);
}